import MobileFilterListItem from "./MobileFilterListItem";

const MobileFilterList = ({
  name,
  selectedItemsLen,
  optionsList,
  valueAddress,
  setSelectedItems,
  unsort,
}) => {
  return (
    <>
      <ul key={name}>
        <span className="pr-5 2xs:max-md:pr-3">
          {name}
          {selectedItemsLen && selectedItemsLen["val"].length > 0 && (
            <span>{` (${selectedItemsLen["val"].length})`}</span>
          )}
        </span>
      </ul>
      <MobileFilterListItem
        category={name}
        optionList={optionsList}
        valueAddress={valueAddress}
        setSelectedItems={setSelectedItems}
        unsort={unsort}
      />
    </>
  );
};
export default MobileFilterList;
